import { render, staticRenderFns } from "./DefaultHelp.vue?vue&type=template&id=74fdff98&scoped=true&"
import script from "./DefaultHelp.vue?vue&type=script&lang=ts&"
export * from "./DefaultHelp.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultHelp.vue?vue&type=style&index=0&id=74fdff98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fdff98",
  null
  
)

export default component.exports